export default "__VITE_ASSET__b0XYSza3__"